export namespace Struct {

	export const struct = 'struct';

	export interface Response {
		status: boolean,
	}

}
